import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import BasicLayout from "../../../layauots/BasicLayout";
import { Card, Alert, AlertTitle, Checkbox, FormControlLabel } from "@mui/material";
import MDBox from "../../../controls/MDBox";
import MDTypography from "../../../controls/MDTypography";
import MDInput from "../../../controls/MDInput";
import MDButton from "../../../controls/MDButton";
import { Save } from "react-bootstrap-icons";
import { ExitToApp } from "@mui/icons-material";
import bgImage from "../../../../assets/images/bg-sign-up-cover.jpeg";
import { getData, pathData, postData } from "../../../Utils/Http/api";

const SujetoContactoTipoEdit = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        idSujetoContactoTipo: id,
        tipoContacto: "",
        activo: true
    });

    const [mensaje, setMensaje] = useState("");
    const [exito, setExito] = useState(false);
    const [grabando, setGrabando] = useState(false);
    const [nombreboton, setnombreboton] = useState("Cancelar");

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await getData(`/SujetoContactoTipoGet/${id}`);

                if (res) {
                    setFormData({
                        idSujetoContactoTipo: res.value.idSujetoContactoTipo,
                        tipoContacto: res.value.tipoContacto,
                        activo: !!res.value.activo
                    });
                }
            } catch (ex) {
                console.error("Error cargando datos:", ex);
            }
        };
        fetchData();
    }, [id]);

    const handleVolver = () => {
        navigate("/SujetoContactoTipoList");
    };

    const handleInputChange = (event) => {
        const { name, value, type, checked } = event.target;
        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value,
        });
    };

    const handleSubmit = async () => {
        try {
            if (!formData.tipoContacto.trim()) {
                setMensaje("El campo Tipo de Contacto es obligatorio");
                setExito(false);
                return;
            }

            setGrabando(true);
            setnombreboton("Volver");
            setMensaje("");

            const payload = { ...formData, activo: formData.activo ? 1 : 0 };
            const res = await pathData("/SujetoContactoTipoUpdate", payload);

            if (res?.isSuccess) {
                setMensaje("¡Tipo de Contacto actualizado exitosamente!");
                setExito(true);
            } else {
                setMensaje(res?.error || "Error al actualizar");
                setExito(false);
                setGrabando(false);
            }
        } catch (error) {
            setMensaje("Error en la solicitud");
            setExito(false);
            setGrabando(false);
        }
    };

    return (
        <BasicLayout image={bgImage}>
            <Card style={{ width: "157%" }}>
                <MDBox
                    variant="gradient"
                    bgColor="secondary"
                    borderRadius="lg"
                    coloredShadow="light"
                    mx={2}
                    mt={-3}
                    p={3}
                    mb={1}
                    textAlign="center"
                >
                    <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                        Editar Tipo de Contacto
                    </MDTypography>
                    <MDTypography display="block" variant="button" color="white" my={1}>
                        Modifica los datos del tipo de contacto seleccionado.
                    </MDTypography>
                </MDBox>

                <MDBox pt={4} pb={3} px={3}>
                    <MDBox component="form" role="form">
                        <MDBox mb={2}>
                            <MDInput
                                type="text"
                                name="tipoContacto"
                                label="Tipo de Contacto"
                                variant="standard"
                                value={formData.tipoContacto}
                                onChange={handleInputChange}
                                fullWidth
                            />
                        </MDBox>
                        <MDBox mb={2}>
                            <FormControlLabel
                                control={<Checkbox name="activo" checked={!!formData.activo} onChange={handleInputChange} />}
                                label="Activo"
                            />
                        </MDBox>

                        <MDBox mb={1} style={{ display: "flex", gap: "16px" }}>
                            <MDButton
                                onClick={handleSubmit}
                                variant="gradient"
                                color="success"
                                endIcon={<Save />}
                                disabled={grabando}
                                fullWidth
                            >
                                Grabar
                            </MDButton>

                            <MDButton
                                onClick={handleVolver}
                                variant="gradient"
                                color="error"
                                endIcon={<ExitToApp />}
                                fullWidth
                            >
                                {nombreboton}
                            </MDButton>
                        </MDBox>
                    </MDBox>

                    {mensaje && (
                        <Alert severity={exito ? "success" : "error"}>
                            <AlertTitle>{exito ? "Felicitaciones" : "Error"}</AlertTitle>
                            {mensaje}
                        </Alert>
                    )}
                </MDBox>
            </Card>
        </BasicLayout>
    );
};

export default SujetoContactoTipoEdit;
